import { z } from 'zod';

const money = z.string().regex(/^\d{1,7}\.\d{2}$/);

const planSchema = z.object({
  id: z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
  name: z.string(),
  description: z.string(),
  monthlyPrice: money,
  annualPrice: money,
  trialDays: z.number().int(),
  vehicleLimit: z.number().int().nullable(),
  staffLimit: z.number().int().nullable(),
  customDomain: z.boolean(),
  features: z.array(z.string()),
  entitlements: z.array(z.string()).default([]),
  active: z.boolean(),
  featured: z.boolean().default(false),
  assignedAgencies: z.number().int().default(0),
});

export type CatalogPlan = z.infer<typeof planSchema>;

export function parseCatalog(payload: unknown): CatalogPlan[] {
  const parsed = z.object({ plans: z.array(planSchema) }).safeParse(payload);
  if (!parsed.success) throw new Error('The plan catalog could not be read.');
  return parsed.data.plans;
}

export function parsePlan(payload: unknown): CatalogPlan {
  const parsed = planSchema.safeParse(payload);
  if (!parsed.success) throw new Error('The plan could not be read.');
  return parsed.data;
}
